import React from 'react';
import './App.css';
import SmoothScroll from './components/SmoothScroll';
import Header from './components/Header';
import Hero from './components/Hero';
import Marquee from './components/Marquee';
import MenuSection from './components/MenuSection';
import Manifesto from './components/Manifesto';
import Footer from './components/Footer';

function App() {
  return (
    <SmoothScroll>
      <div className="App">
        <Header />
        <Hero />
        <Marquee />
        <MenuSection />
        <Manifesto />
        <Marquee />
        <Footer />
      </div>
    </SmoothScroll>
  );
}

export default App;